module.exports = __webpack_public_path__ + "img/student_report_01.ab8bf720.png";